import { FC } from 'react'
import { Switch } from '@wellesley/ui'

type AutoDetectSwitchProps = {
  checked: boolean
  isDetecting: boolean
  onCheckedChange: (checked: boolean) => void
}

const AutoDetectSwitch: FC<AutoDetectSwitchProps> = ({
  checked,
  isDetecting,
  onCheckedChange,
}) => (
  <div className="p-xxs flex items-center justify-between">
    <span className="text-base font-medium">
      {isDetecting ? 'Detecting…' : 'Set location automatically'}
    </span>
    <Switch
      checked={checked}
      disabled={isDetecting}
      onCheckedChange={onCheckedChange}
      data-testid="location-autodetect-toggle"
    />
  </div>
)

export default AutoDetectSwitch
